import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { menuItems } from '../../constants/menuItems';
import { Box, Typography, CircularProgress } from '@mui/material';

const Home: React.FC = () => {
  const navigate = useNavigate();
  const { hasRole } = useAuth();

  useEffect(() => {
    // Find the first menu item the user has access to
    const firstAvailableItem = menuItems.find(item => hasRole(item.roles));
    
    if (firstAvailableItem) {
      navigate(firstAvailableItem.path, { replace: true });
    }
  }, [navigate, hasRole]);

  // Show loading while redirecting, or a message if no access
  const visibleMenuItems = menuItems.filter(item => hasRole(item.roles));
  
  if (visibleMenuItems.length === 0) {
    return (
      <Box p={3}>
        <Typography variant="h4" gutterBottom>
          E2E C.E.P.
        </Typography>
        <Typography variant="body1" color="error">
          You do not have access to any sections of this application.
        </Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
      <CircularProgress />
    </Box>
  );
};

export default Home;
